import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import CrossSellingModalCategories from './containers/CrossSellingModalCategories/CrossSellingModalCategories';
import CrossSellingModalItems from './containers/CrossSellingModalItems/CrossSellingModalItems';
import { crossSellingModalStore } from './store';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalActionButton from 'src/view/components/Controls/Modal/ModalActionButton/ModalActionButton';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalFooter from 'src/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { BUTTON_TITLE } from '~/constants/main';
import './style.scss';

const CrossSellingModal: FC = observer((): JSX.Element => {
  useEffect(() => {
    crossSellingModalStore.fetchCategories();
  }, []);

  return (
    <CustomModalComponent isOpen={true} onRequestClose={crossSellingModalStore.closeModal} className="cross-selling-modal" withCloseIcon>
      <ModalBackground>
        {/* header */}
        <ModalHeader title={localeStore.t('cross_selling_items')} />

        {/* categories */}
        <ScrollableBlock
          className="cross-selling-modal__crumbs-wrapper mx-8 mt-3"
          scrollClassName="full-height"
          direction="horizontal"
          showScrollbar
          scrollbarSize="small">
          <CrossSellingModalCategories />
        </ScrollableBlock>

        {/* control buttons */}
        <div className="d-flex flex-row justify-content-end mt-1 mr-8 gap-20">
          <ModalActionButton title={localeStore.t('select_all')} onClick={crossSellingModalStore.selectAll} />
          <ModalActionButton title={localeStore.t('deselect_all')} onClick={crossSellingModalStore.deselectAll} />
        </div>

        {/* items */}
        <ScrollableBlock className="d-flex flex-1 mx-8 mt-6" scrollClassName="full-height" showScrollbar scrollbarSize="small">
          <CrossSellingModalItems />
        </ScrollableBlock>

        {/* save button */}
        <ModalFooter>
          <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={crossSellingModalStore.clickSave} loading={crossSellingModalStore.loading} />
        </ModalFooter>
        {/* loading overlay */}
        <LoadingOverlay visible={crossSellingModalStore.loading} />
      </ModalBackground>
    </CustomModalComponent>
  );
});

export default CrossSellingModal;
